<template>
  <div class="reschedule-main-filter">
    <subheader
      title="Busca"
      class="alternative-subheader"
    />

    <div
      class="reschedule-main-filter__container"
    >
      <div class="cards-filter-container__tabs">
        <div
          id="filterTab"
          class="cards-filter-container__tabs-single"
          :class="{ 'cards-filter-container__tabs-selected': tabSelected }"
          @click="changeTab(true)"
        >
          Específica
        </div>
      </div>
    </div>
    <div
      v-if="tabSelected"
      class="cards-filter-container__filter"
    >
      <div class="cards-filter-container__filter-field-area">
        <div class="input-layout-container">
          <md-input-container placeholder="Buscar">
            <md-input
              v-model="orderId"
              v-validate="'required|numeric'"
              :placeholder="'Digite o número da OS Álvaro'"
              data-vv-validate-on="change|blur"
              :name="type"
              @keydown.enter.native="search(errors)"
            />
          </md-input-container>
        </div>
      </div>
      <div class="cards-filter-container__filter-field-area">
        <md-radio
          v-model="type"
          md-value="OA"
          class="cards-filter-container__filter-checkbox"
        >
          OS Alvaro
        </md-radio>
      </div>
      <div class="cards-filter-container__filter-container-button">
        <md-button
          class="btn btn-primary cards-filter-container__filter-button cards-filter-container__filter-button-right"
          @click="search(errors)"
        >
          <md-icon :md-src="'/static/images/icon-generate-list.svg'" />Buscar
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '../common/SubHeader'
import notify from '@/api/notification'

const PARAM_SEARCH_OS_ALVARO = 'OA'

export default {
  name: 'RescheduleMainFilter',
  components: {
    subheader: SubHeader
  },
  data: () => ({
    tabSelected: true,
    type: PARAM_SEARCH_OS_ALVARO,
    orderId: ''
  }),
  methods: {
    search (errors) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$router.push({
            path: '/reschedule/search',
            query: { orderId: this.orderId }
          })
          return
        } else {
          let ERROR_MSG
          if (errors.items[0].rule === 'required') {
            ERROR_MSG = 'Digite algo para pesquisar.'
          } else if (errors.items[0].rule === 'numeric') {
            ERROR_MSG = 'Insira apenas números, sem espaços.'
          }
          notify({
            title: 'AVISO:',
            message: ERROR_MSG
          })
        }
      })
    },
    changeTab (value) {
      this.tabSelected = value
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";

.reschedule-main-filter {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: $mainHeaderHeight;

  &__container {
    flex-flow: column wrap;
    display: block;
    min-width: 555px;
    margin-top: 10%;
  }

  &__title {
    line-height: 26px;
    text-align: left;
    color: #7a7a7a;
    font-weight: 500;
    letter-spacing: 0.8px;
    margin-left: 1em;
    font-size: 14px;
  }

  .cards-filter-container {
    display: flex;

    &__tabs {
      display: flex;
      margin-top: 10px;
      margin-left: 8px;

      &-single {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding: 10px 40px 10px 40px;
        background-color: rgba(255, 255, 255, 0.5);
        margin-right: 3px;
        cursor: pointer;
        line-height: 26px;
        text-align: left;
        color: #7a7a7a;
        font-weight: 500;
        letter-spacing: 0.8px;
        font-size: 14px;
      }

      &-selected {
        background-color: white;
      }
    }

    &__filter {
      background-color: white;
      border-radius: 5px;
      border-top-left-radius: 0px;
      margin-left: 15px;
      padding: 15px;
      min-width: 555px;

      &-field-area {
        background-color: rgba(127, 26, 84, 0.1);
        padding-right: 12px;
        padding-left: 12px;
        border-radius: 5px;
        margin-bottom: 15px;

        .label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-top: 5px;
          padding-right: 15px;
          letter-spacing: 1px;
          text-transform: uppercase;
          position: relative;
          bottom: 0.3em;
        }
      }

      &-container-button {
        display: flex;
        justify-content: flex-end;
      }

      &-button {
        width: 48%;

        &-right {
          margin-left: 3%;
        }
      }

      .btn-nonenary {
        .md-icon {
          > svg .color {
            fill: $brand-primary;
            transition: 0.6s;
          }
        }

        &:hover .md-icon > svg .color {
          fill: white;
          transition: 0.6s;
        }
      }

      .md-input-container {
        background-color: white;
        border-radius: 5px;
        min-height: auto;
        margin: 0px;
        padding-top: 0px;
        padding-right: 10px;
      }

      .input-layout-container,
      .date-range-container {
        display: flex;

        &-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-top: 5px;
          padding-right: 10px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
      }
      .date-range-container {
        padding-top: 15px;
        padding-bottom: 15px;

        .search-bar__date {
          margin: 0;
        }

        .md-input-container input,
        .md-input-container textarea {
          min-width: 240px;
        }

        .md-input-container.md-has-value input,
        .md-input-container.md-has-value textarea,
        .md-input-container.md-input-focused input,
        .md-input-container.md-input-focused textarea {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 450;
          padding-left: 10px;
          letter-spacing: 1px;
        }
      }

      .md-input-container.md-input-placeholder input, .md-input-container.md-input-placeholder textarea {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 450;
        padding-left: 10px;
        letter-spacing: 1px;
      }

      .date-range-container,
      .input-layout-container {
        padding-top: 7px;
        padding-bottom: 7px;

        &-label {
          justify-content: right;
          display: flex;
          width: 18%;
        }

        .md-input-container.md-has-value input,
        .md-input-container.md-has-value textarea,
        .md-input-container.md-input-focused input,
        .md-input-container.md-input-focused textarea {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 450;
          padding-left: 10px;
          letter-spacing: 1px;
        }
      }

      .date-range-container {
        .md-input-container {
          max-width: 100%;

          &::after {
            display: none;
          }
        }
      }

      .input-layout-container {
        .md-input-container {
          max-width: 100%;

          &::after {
            display: none;
          }
        }
      }

      .md-checkbox {
        margin-right: 2em;
        margin-top: 13px;
        margin-bottom: 13px;

        .md-checkbox-container {
          background-color: white;
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 3px;
        }
      }

      .md-theme-default.md-checkbox.md-checked .md-checkbox-container {
        background-color: $brand-primary;
        border: 2px solid $brand-primary;
      }

      .md-checkbox-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-bottom: 10px;
        letter-spacing: 0.8px;
      }

      .md-radio {
        margin-right: 2em;

        .md-radio-container {
          background-color: white;
          border: 2px solid rgba(255, 255, 255, 1);
        }
      }

      .md-theme-default.md-radio.md-checked .md-radio-container {
        background-color: white;
        border: 2px solid white;
      }

      .md-radio-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-bottom: 10px;
        letter-spacing: 0.8px;
      }

      .md-theme-default.md-radio .md-radio-container::after {
        background-color: $brand-primary;
      }
    }
  }

}
</style>
